import React from "react";
import Layout from "../atoms/Layout";
import AuftragsInput from "../atoms/AuftragsInput/AuftragsInput";
import { useHistory } from "react-router";
import { Base64 } from "js-base64";
import Note from "../atoms/Note/Note";
import useAuthedOnly from '../hooks/useAuthedOnly';

const AuftragStep1 = () => {
  let authed = useAuthedOnly({});
  let history = useHistory();
  return (
    <Layout title="Lieferschein erstellen" width={900}>
      <AuftragsInput
        buttonText="Weiter zu Schritt 2"
        onFinish={(d) => {
          history.push("/lieferschein/" + Base64.encode(JSON.stringify(d)));
        }}
      ></AuftragsInput>
    </Layout>
  );
};

export default AuftragStep1;
